// Messages Page
export default function Messages() { return <div><h1 className="text-3xl font-bold">Messages</h1><p className="mt-4">Communicate with coaches and staff.</p></div>; }